import React from "react";

function EmployeeDetails({
  userLogin,
  empDetails,
  clickView,
  clickEdit,
  clickStatus,
  clickDone,
}) {
  const downloadFile = () => {
    window.open(empDetails?.quitClaim, "_blank");
  };
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Employee Details
      </h6>
      <p className="mb-1">
        <strong>Employee Name:</strong> {empDetails?.firstName}{" "}
        {empDetails?.middleName} {empDetails?.lastName}
      </p>
      <p className="mb-1">
        <strong>Position:</strong> {empDetails?.position}
      </p>
      <p className="mb-1">
        <strong>Date Hired:</strong> {empDetails?.dateHired}
      </p>
      <p className="mb-1">
        <strong>Status:</strong> {empDetails?.status}
      </p>

      {empDetails?.address ? (
        <p className="mb-1">
          <strong>Address:</strong> {empDetails?.address}
        </p>
      ) : (
        ""
      )}

      {empDetails?.mobileNumber ? (
        <p className="mb-1">
          <strong>Phone Number:</strong> {empDetails?.mobileNumber}
        </p>
      ) : (
        ""
      )}

      {empDetails?.email ? (
        <p className="mb-1">
          <strong>Email Address:</strong> {empDetails?.email}
        </p>
      ) : (
        ""
      )}

      {/* Buttons */}
      {userLogin.roles[0].id === "Admin" ? (
        <>
          <div className="mt-3">
            <button
              className="btn text-white w-100"
              style={{ backgroundColor: "#d18237" }}
              onClick={() => clickView()}
            >
              View Employee
            </button>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <button
              className="btn text-dark flex-grow-1 me-2"
              style={{ backgroundColor: "#e5e5e5" }}
              onClick={() => clickEdit()}
            >
              Edit
            </button>
            <button
              className="btn text-white flex-grow-1"
              style={{ backgroundColor: "#3f7cc0" }}
              onClick={() => clickStatus()}
            >
              Change Status
            </button>
          </div>
        </>
      ) : (
        <div className="mt-3">
          <button
            className="btn text-white w-100"
            disabled={empDetails?.quitClaim}
            style={{ backgroundColor: "#d18237" }}
            onClick={() => clickDone()}
          >
            Done
          </button>
          {empDetails?.quitClaim && (
            <button
              className="btn text-white w-100 mt-2 bg-success"
              style={{ backgroundColor: "#d18237" }}
              onClick={() => downloadFile()}
            >
              <i class="bi bi-file-earmark-arrow-down me-2"></i>Redownload
              Quitclaim
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default EmployeeDetails;
